import React from 'react';
import './AboutPAPT.css';  // Keep this for styles

const VisionMission = () => {
  return (
    <div className="vision-mission-container">
      <h2 className="section-title12">VISION & MISSION</h2>
    
      <div className="vision-section">
        <h3>Vision</h3>
        <p>
          PAPT is envisaged as a centre of evolution for excellence in Technological and Research Education. The institution aspires to spread universal knowledge through villages and cities enabling expansion of human resources.
        </p>
      </div>

      <div className="mission-section">
        <h3>Mission</h3>
        <ul>
          <li>
            To provide career-oriented professional education to produce technically competent engineers and managers with moral and ethical values.
          </li>
          <li>
            To foster and promote an effective learning environment in the campus to be recognized as a place that encourages excellence and diversity in thoughts and endeavour.
          </li>
          <li>
            To provide research and intellectual resources to address problems facing the industry and the society while advancing the scopes of multidisciplinary applications.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default VisionMission;
